
import React from "react";
import { RemixIcon } from "@/components/shared/RemixIcon";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  icon: string;
  change?: string;
  trend?: "up" | "down" | "neutral";
  className?: string;
}

export function StatCard({ 
  title, 
  value, 
  icon, 
  change, 
  trend = "neutral",
  className
}: StatCardProps) {
  return (
    <div className={cn(
      "glass-card p-6 rounded-xl animate-slideUp shadow-sm hover:shadow-md transition-all",
      className
    )}>
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
          <RemixIcon name={icon} size="xl" />
        </div>
      </div>
      <div className="mt-2">
        <p className="text-3xl font-bold">{value}</p>
        {change && (
          <p className={cn(
            "text-sm mt-2 flex items-center gap-1",
            trend === "up" && "text-green-500",
            trend === "down" && "text-red-500",
            trend === "neutral" && "text-muted-foreground"
          )}>
            {trend === "up" && <RemixIcon name="arrow-up-s-line" size="sm" />}
            {trend === "down" && <RemixIcon name="arrow-down-s-line" size="sm" />}
            {change}
          </p>
        )}
      </div>
    </div>
  );
}
